import { render, staticRenderFns } from "./MotivationSection.vue?vue&type=template&id=018eb53a&scoped=true&"
import script from "./MotivationSection.vue?vue&type=script&lang=js&"
export * from "./MotivationSection.vue?vue&type=script&lang=js&"
import style0 from "./MotivationSection.vue?vue&type=style&index=0&id=018eb53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018eb53a",
  null
  
)

export default component.exports